import { state } from './publish-purchase.state.js';
import { getters } from './publish-purchase.getters.js';
import { actions } from './publish-purchase.actions.js';
import { mutations } from './publish-purchase.mutations.js';

export default {
  state,
  getters,
  actions,
  mutations
};
